import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './dialog.less'

class Dialog extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    onClose: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.body.style.overflow = ''
  }

  render() {
    return (
      <div styleName="dialog-container">
        <div styleName={`${this.props.size}-dialog`}>
          <span
            className="icon icon-small icon-close-small"
            styleName="x-button"
            onClick={this.props.onClose}
          />
          <div styleName="dialog-contents">{this.props.children}</div>
        </div>
      </div>
    )
  }
}

export default cssModules(Dialog, styles)
